import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { languages } from '../i18n/index'
import VueCookies from 'vue-cookies'
import axios from 'axios'

Vue.use(VueI18n)
Vue.use(VueCookies)

export const i18n = new VueI18n({
  locale: Vue.$cookies.get('lang'), // set locale
  fallbackLocale: 'en',
  languages // set locale messages
})



const loadedLanguages = [] // our default language that is preloaded

function setI18nLanguage (lang) {
  i18n.locale = lang
  axios.defaults.headers.common['Accept-Language'] = lang
  document.querySelector('html').setAttribute('lang', lang)
  return lang
}

export async function loadLanguageAsync(lang) {
  let burl = null
  if(process.env.NODE_ENV === 'production'){
    
    burl = 'https://api.prime-shipping.net/'
  }else{
    burl = 'http://localhost:5000/'
    
  }
  // If the same language
  /*if (i18n.locale === lang) {
    return Promise.resolve(setI18nLanguage(lang))
  }*/

  // If the language was already loaded
  /*if (loadedLanguages.includes(lang)) {
    return Promise.resolve(setI18nLanguage(lang))
  }*/

  // If the language hasn't been loaded yet
  const response = await axios.get(`${burl}prime/api/website/get/lang/${lang}`)
  let msgs = response.data
  loadedLanguages.push(lang)
  i18n.setLocaleMessage(lang, msgs)
  setI18nLanguage(lang)
}



// WEBPACK FOOTER //
// ./src/plugins/i18n.js